// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"LoadingOverlay_loading-wrapper__wABEY","show":"LoadingOverlay_show__fc2lm"};